// Rails' CSRF token for the fetch calls the Hudini panel makes (send, stop,
// redo, context uploads). Read on every call rather than cached at connect,
// since a Turbo page load can replace the meta tag under a panel that stays
// mounted in the dock.
export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

// Merges the CSRF header into a fetch options object.
export function withCsrf(options = {}) {
  return { ...options, headers: { "X-CSRF-Token": csrfToken(), ...(options.headers || {}) } }
}

// The JSON flavor: same header, plus the content type and an encoded body.
export function jsonRequest(method, body) {
  return withCsrf({
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
}
